import React from 'react';
import img from '../Pages/image/bg.jpg'


const About = () => {
    return (
        <div>


<section class="text-gray-600 body-font">
  <div class="container mx-auto flex px-5 lg:py-24 py-12 md:flex-row flex-col items-center">
  <div class=" md:w-1/2 w-full mb-10 md:mb-0">
      <img class="object-cover shadow object-center rounded h-2/4" alt="hero" src={img}/>
    </div>
    <div class="flex flex-col flex-wrap lg:py-6 -mb-10 lg:w-1/2 lg:pl-12 lg:text-left text-center">
      <div class="flex flex-col mb-10 lg:items-start items-center">
        <div class="flex-grow">
          <h2 class="text-white lg:text-6xl text-4xl font-bold mb-8 px-16 gradient ">I'm Foyjur Rahman</h2>
          <p class="leading-relaxed text-white lg:text-left text-center font-lg  px-16">I have been working as full stack web developer for a year.I'm Junior Full stack Web developer and UI/UX Designer with 2 years experienced.As a Developer I love to develop product from sketch to useful and useable application for end user.Learning new technology is my motive to go one step forward in future. </p>
        <p className='px-16 text-white font-lg mt-8'>I'm crazy about code because I leave my accountant career just to do my loving one it was painful and hard broken process but I'm with loving one</p>
        <p className='font-medium text-lg text-white px-16 mt-5'>My working arms Collection  </p>
        <p></p>
        </div>
      </div>
   
      <div className='grid grid-rows-3 px-16 grid-flow-col mb-5 ' >
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox bg mr-2" /><p className='font-medium text-white text-lg text-left'>HTML</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox bg mr-2" /><p className='font-medium text-white text-lg text-left'>CSS</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox bg mr-2" /><p className='font-medium text-white text-lg text-left'>React js</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox bg mr-2" /><p className='font-medium text-white text-lg text-left'>Next js</p> </div>
              <div  className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg text-left mb-8'>Tailwind</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-left'>Node js</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg  text-left'>Express.js</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg  text-left'>Mongodb</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg  text-left'>Firebase</p> </div>
              <div className='flex'><input type="checkbox" checked="checked" class="checkbox  mr-2" /><p className='font-medium text-white text-lg  text-left'>JWT</p> </div>
              </div>
      <div className='item-center pr-12'><button class="btn bg shadow mt-8 ml-16"><a className='text-white' href='https://github.com/foyjur-192' target="_blank" rel='noopener noreferrer'>My Github</a></button></div>
   
    </div>
   
  </div>
</section>






        </div>
    );
};

export default About;